var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('derive',{attrs:{"titleStr":"导出考试小题分","data":_vm.dataArr,"onDerive":_vm.onDerive,"formData":_vm.dataForm,"infoArr":_vm.placeholder}})],1),_c('div',{staticStyle:{"width":"calc(100% - 100rem)","height":"1rem","background":"#EFEFEF","margin":"24rem 50rem 0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }